import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface EnvState {
    selectedEnvItem: string
}
  
const envInitialState: EnvState = {
    selectedEnvItem: "uat"
}

const setInitialEnv = () => {
  window.localStorage.setItem("env", "uat");
  window.localStorage.setItem("previousEnv", "uat");
  return envInitialState
}

export const envSlice = createSlice({
    name: 'env',
    initialState : setInitialEnv(),
    reducers: {
      setEnvState: (state, action: PayloadAction<string>) => {
        state.selectedEnvItem = action.payload
        // to access this in auth client provider
        window.localStorage.setItem("env", action.payload)
      }
    }
});

export const envReducer = envSlice.reducer;